var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "KModal",
    {
      attrs: {
        cancelText: _vm.cancelText,
        title: _vm.title,
        submitText: _vm.submitText,
        size: _vm.modalSize,
        submitDisabled: _vm.disabled,
        "data-test": "dateRangeModal",
      },
      on: {
        submit: _vm.onSubmit,
        cancel: function ($event) {
          return _vm.$emit("cancel")
        },
      },
    },
    [
      _c(
        "div",
        [
          _vm._t("description", function () {
            return [
              _c(
                "p",
                {
                  ref: "description",
                  staticClass: "description",
                  attrs: { id: "modal-description" },
                },
                [_vm._v("\n        " + _vm._s(_vm.description) + "\n      ")]
              ),
            ]
          }),
          _c("div", { staticClass: "date-inputs" }, [
            _c(
              "div",
              { staticClass: "left-input" },
              [
                _c("KDateInput", {
                  attrs: {
                    value: _vm.dateRange.start,
                    inputRef: "dateStartRangeInput",
                    errorMessage: _vm.invalidStartErrorMessage,
                    legendText: _vm.startDateLegendText,
                    "data-test": "startDate",
                  },
                  on: { updateDate: _vm.debouncedSetStartDate },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "right-input" },
              [
                _c("KDateInput", {
                  attrs: {
                    value: _vm.dateRange.end,
                    inputRef: "dateEndRangeInput",
                    errorMessage: _vm.invalidEndErrorMessage,
                    legendText: _vm.endDateLegendText,
                    "data-test": "endDate",
                  },
                  on: { updateDate: _vm.debouncedSetEndDate },
                }),
              ],
              1
            ),
          ]),
          _c(
            "div",
            [
              _c(
                "KDateCalendar",
                _vm._b(
                  {
                    attrs: {
                      firstAllowedDate: _vm.firstAllowedDate,
                      lastAllowedDate: _vm.lastAllowedDate,
                      selectedStartDate: _vm.createDate(_vm.dateRange.start),
                      selectedEndDate: _vm.createDate(_vm.dateRange.end),
                      previousMonthText: _vm.previousMonthText,
                      nextMonthText: _vm.nextMonthText,
                    },
                    on: {
                      updateSelectedDates: _vm.setSelectedDatesFromCalendar,
                    },
                  },
                  "KDateCalendar",
                  _vm.dateRange,
                  false,
                  true
                )
              ),
            ],
            1
          ),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }